import { queryOptions } from '@tanstack/react-query'

import { fetchInHouse } from '../api'
import { partnersQueryKeys } from '../query-keys'

export const getInHouseQueryOptions = (param: {
  tenantKey: string
  dcId: number
}) =>
  queryOptions({
    queryKey: partnersQueryKeys.inHouse(param.tenantKey, param.dcId),
    queryFn: async ({ signal }) =>
      fetchInHouse(
        {
          tenantKey: param.tenantKey,
          query: { dcId: param.dcId }
        },
        signal
      ),
    // 配車板の仮想リストは行コンポーネント(DispatchSchedule)が in-house を購読するため、
    // スクロールで行がマウントされるたび refetchOnMount で再取得されてしまう(#5481)。
    // in-house は拠点ごと 1 件の設定値で頻繁に変わらないため staleTime でキャッシュし、
    // 大量マウント時の連続フェッチを抑える(対照実装 useWeightDisplayFormat #4905 と同方針)。
    // 設定保存後の反映漏れは in-house / own-partner 設定画面の保存時 invalidate で担保する。
    staleTime: 1000 * 60 * 5 // 5分間キャッシュ
  })
